"use client";

import { useRouter } from "next/navigation";
import { BUILDER_CHART_HTML } from "./builder-chart.html";

/** Strategy Builder (chart mode) — EXACT reference render. */
export function BuilderChartContent() {
  const router = useRouter();

  const handleContainerClick = (e: React.MouseEvent<HTMLElement>) => {
    const btn = (e.target as HTMLElement).closest<HTMLElement>("button[formaction], a[formaction], [data-href]");
    if (btn) {
      const action = btn.getAttribute("formaction") || btn.getAttribute("data-href");
      if (action) {
        e.preventDefault();
        router.push(action);
      }
    }
  };

  return (
    <div
      onClick={handleContainerClick}
      style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", minHeight: 0, flex: 1 }}
      dangerouslySetInnerHTML={{ __html: BUILDER_CHART_HTML }}
    />
  );
}
